const items = [
  "VOICE",
  "HEART",
  "RESONANCE",
  "FREQUENCY",
  "CONNECTION",
  "EXPRESSION",
  "HUMAN TRANSFORMATION",
];

const Row = ({ ariaHidden }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-serif-display px-10 text-2xl font-light italic tracking-wide text-[#b8912e]/80 md:text-3xl">
          {item}
        </span>
        <span className="h-1 w-1 rounded-full bg-[#8a6d1f]/50" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y hairline py-8">
    <div className="marquee-track flex w-max">
      <Row ariaHidden={false} />
      <Row ariaHidden={true} />
    </div>
  </div>
);

export default Marquee;
